<template>
  <div>
    <div class="flex-column flex-center" style="width: 100vw; min-height: 100vh; background-color: #fff; padding-bottom: 80px" v-if="pcFlag">
      <img :src="appInfo.image" alt="" style="width: 98px; height: 98px; border-radius: 10px" />
      <span style="font-size: 16px; font-weight: 700; color: #000; margin: 20px 0">{{ appInfo.ipa_name }}</span>
      <img :src="qrcode" alt="" style="width: 220px; height: 220px" />
      <span style="font-size: 16px; font-weight: 700; color: #000; margin: 20px 0">{{ $t('temp7.scan') }}</span>
    </div>
    <hongbao v-else-if="!ishome" @back="toggleBack" :appInfo="appInfo" :hongbaoAd="hongbaoAd" :whiteList="whiteList" :jumpObject="jumpObject" />
    <div class="flex-column" style="width: 100vw; min-height: 100vh; background-color: #fff; padding-bottom: 130px" v-else-if="!pcFlag">
      <div class="w100 flex-column flex-center" style="background: linear-gradient(172deg, #62bbe3 6.16%, #fff 57.88%); height: 280px">
        <span style="color: #0c4889; font-size: 22px; font-weight: 700">{{ appInfo.ipa_name }}</span>
        <div class="flex" style="margin-top: 10px; align-items: center">
          <div class="flex-center" style="background-color: #fff; border-radius: 50%; width: 24px; height: 24px">
            <img src="./static/android.png" alt="" style="width: 15px; height: 15px" v-if="mime == 'Android'" />
            <img src="./static/ios.png" alt="" style="width: 15px; height: 15px" v-else />
          </div>
          <span style="color: #4593fc; font-size: 14px; margin-left: 4px">{{ mime == 'Android' ? 'Android' : 'Apple' }} Inc.</span>
        </div>
        <img :src="appInfo.image" alt="" style="width: 90px; height: 90px; margin-top: 20px; border-radius: 10px" />
        <div class="w100 flex-center" style="gap: 10px; margin-top: 20px">
          <div class="tag">{{ mime == 'Android' ? 'Android' : 'Apple' }}{{ $t('temp7.shouquan') }}</div>
          <div class="tag">V{{ appInfo.xlversion }}</div>
          <div class="tag">{{ $t('temp7.bangdan') }}</div>
        </div>
      </div>
      <div class="w100" style="padding: 0 20px; margin-top: 20px">
        <div class="statisticsBox">
          <div class="flex-column" style="align-items: center">
            <span style="font-size: 12px; color: #7193b8">{{ $t('temp7.pingjun') }}</span>
            <span style="font-size: 20px; color: #141414; margin-top: 7px">4.9</span>
          </div>
          <div class="flex-column" style="align-items: center">
            <span style="font-size: 12px; color: #7193b8">{{ $t('temp7.totalTimes') }}</span>
            <span style="font-size: 20px; color: #141414; margin-top: 7px">{{ $t('temp7.9_6w') }}</span>
          </div>
          <div class="flex-column" style="align-items: center">
            <span style="font-size: 12px; color: #7193b8">{{ $t('temp7.totalDownload') }}</span>
            <span style="font-size: 20px; color: #141414; margin-top: 7px">{{ $t('temp7.10w') }}</span>
          </div>
        </div>
      </div>
      <div class="w100 flex-column" style="padding: 0 20px; margin-top: 30px" v-if="appInfo.logmassage">
        <span class="w100" style="color: #02387c; font-size: 20px">{{ $t('temp7.jianjie') }}</span>
        <div class="w100" style="margin-top: 10px">
          <span style="font-size: 15px; color: #303030">{{ appInfo.logmassage }}</span>
        </div>
      </div>
      <!-- 预览图 -->
      <div class="w100" style="padding: 0 20px; margin-top: 30px">
        <div style="width: 100%; display: flex; flex-direction: column" v-if="appInfo.preview">
          <div style="padding: 0 30px 20px 0px; font-size: 18px; color: #02387c">{{ $t('index.yy') + $t('index.jt') }}</div>
          <div style="padding: 0 0px 0; width: 100%; overflow-x: scroll; overflow-y: hidden; display: flex; flex-wrap: nowrap; margin: 0px auto 0; scrollbar-width: none">
            <img :src="item" style="width: 35%; margin-right: 15px; border-radius: 8px" alt="" v-for="(item, index) in appInfo.preview" :key="index" />
          </div>
        </div>
      </div>

      <div class="w100 flex-between" style="padding: 0 20px; margin-top: 20px">
        <div class="flex-column">
          <span style="color: #02387c; font-size: 20px">{{ $t('temp7.pingfen') }}</span>
          <span style="color: #7193b8; font-size: 14px; margin-top: 3px">{{ $t('temp7.9_6w') }}{{ $t('temp7.pingfenTimes') }}</span>
        </div>
        <div class="flex" style="align-items: center">
          <span style="font-size: 48px; color: #000c00; margin-right: 5px">4.9</span>
          <img src="./static/star.png" alt="" style="width: 40px; height: 40px" />
        </div>
      </div>
      <div class="w100 flex-column" style="padding: 0 20px; margin-top: 10px">
        <div class="w100 flex-column" v-for="(item, index) in starList" :key="index" style="margin-bottom: 10px">
          <div class="w100 flex-between">
            <div class="flex" style="column-gap: 8px">
              <img src="./static/star.png" alt="" style="width: 12px; height: 12px" v-for="it in item.star" :key="it" />
            </div>
            <span style="color: #7193b8; font-size: 12px">{{ item.percentage }}%</span>
          </div>
          <mu-linear-progress mode="determinate" :value="item.percentage" color="#4593fc"></mu-linear-progress>
        </div>

        <div class="w100 flex-column" style="background-color: #f4f4f4; border-radius: 16px; padding: 20px 15px; margin-top: 20px">
          <div class="w100" style="color: #000; font-size: 16px">{{ $t('temp7.good') }}</div>
          <span style="color: #7193b8; font-size: 12px">William</span>
          <div class="w100" style="border-top: 1px solid rgba(217, 217, 217, 1); padding: 6px 0">
            <div class="flex">
              <img src="./static/star.png" alt="" style="width: 12px; height: 12px" v-for="it in 5" :key="it" />
            </div>
            <div class="w100">
              <span style="color: #303030; font-size: 15px">{{ $t('temp7.goodDesc') }}</span>
            </div>
            <div style="margin-top: 5px; color: #7193b8; font-size: 12px">{{ today }}</div>
          </div>
        </div>
        <div class="w100 flex-column" style="margin-top: 20px">
          <span style="color: #02387c; font-size: 20px">{{ $t('temp7.message') }}</span>

          <div class="w100 flex-between" style="border-bottom: 1px solid rgb(217, 217, 217); padding: 15px 0; margin-top: 20px">
            <span style="color: #7193b8; font-size: 16px">{{ $t('index.gongys') }}</span>
            <span style="color: #303030; font-size: 16px">{{ appInfo.ipa_name }}</span>
          </div>
          <div class="w100 flex-between" style="border-bottom: 1px solid rgb(217, 217, 217); padding: 15px 0">
            <span style="color: #7193b8; font-size: 16px">{{ $t('temp7.size') }}</span>
            <span style="color: #303030; font-size: 16px">{{ appInfo.filesize }}</span>
          </div>
          <div class="w100 flex-between" style="border-bottom: 1px solid rgb(217, 217, 217); padding: 15px 0">
            <span style="color: #7193b8; font-size: 16px">{{ $t('temp7.jianrong') }}</span>
            <span style="color: #303030; font-size: 16px">{{ $t('temp7.canUse') }}</span>
          </div>
          <div class="w100 flex-between" style="border-bottom: 1px solid rgb(217, 217, 217); padding: 15px 0">
            <span style="color: #7193b8; font-size: 16px">{{ $t('temp7.language') }}</span>
            <span style="color: #303030; font-size: 16px">{{ $t('temp7.languageDesc') }}</span>
          </div>
          <div class="w100 flex-between" style="border-bottom: 1px solid rgb(217, 217, 217); padding: 15px 0">
            <span style="color: #7193b8; font-size: 16px">{{ $t('index.jiage') }}</span>
            <span style="color: #303030; font-size: 16px">{{ $t('index.free') }}</span>
          </div>
          <div class="w100 flex-between" style="border-bottom: 1px solid rgb(217, 217, 217); padding: 15px 0">
            <span style="color: #7193b8; font-size: 16px">{{ $t('temp7.age') }}</span>
            <span style="color: #303030; font-size: 16px">18+</span>
          </div>
          <div class="w100 flex-between" style="padding: 15px 0">
            <span style="color: #7193b8; font-size: 16px">{{ $t('index.banquan') }}</span>
            <span style="color: #303030; font-size: 16px">©️ {{ year }} {{ appInfo.ipa_name }}</span>
          </div>
          <div style="margin-top: 20px; font-size: 14px; color: #000">
            <span>{{ $t('temp7.mianze') }}</span>
            <span style="color: #7193b8" @click="report">{{ $t('temp7.jubao') }}</span>
          </div>
        </div>
      </div>

      <div class="bottomBtn flex-center" style="column-gap: 10px; padding-top: 25px">
        <div class="installBtn" style="background: #666" v-if="cannotInstall">{{ $t('index.free') + $t('index.install') }}</div>
        <div class="installBtn" @click="installApp(false)" style="" v-else>
          <span v-if="downloaded">{{ $t('index.back_desktop') }}</span>
          <span v-else>{{ downloadFlag ? $t('index.installing') : $t('temp4.install') }}</span>
        </div>
        <div class="xinren" @click="installTipShow = true" v-if="mime != 'Android' && !androidFlag">{{ $t('index.go_cert') }}</div>
      </div>
    </div>
    <mu-dialog :append-body="false" width="80%" :open.sync="installTipShow" style="border-radius: 15px">
      <div style="width: 100%; display: flex; flex-direction: column">
        <div style="width: 100%">
          <span>1.{{ $t('index.cert_before') }}</span>
          <span style="color: #cc0000">{{ $t('index.app_must') }}</span>
        </div>
        <div style="width: 100%">
          <span>2.{{ $t('index.you_need') }}</span>
          <span style="color: #cc0000">{{ $t('index.setting_step') }}</span>
          <span>{{ $t('index.company_app') }}</span>
        </div>
      </div>
      <!-- <mu-button slot="actions" flat small textColor="#2196f3" @click="(installTipShow = false), (tipsShow = true)">{{ $t('index.text_img') }}</mu-button> -->
      <mu-button slot="actions" flat small textColor="#2196f3" @click="goCert">{{ $t('index.confirm') }}</mu-button>
    </mu-dialog>
    <report :baseUrl="baseUrl" :appInfo="appInfo" :appid="appInfo.id || 0" ref="report"></report>
  </div>
</template>

<script>
import report from '../report/report.vue';
import hongbao from './hongbao';
import { mixin } from '../../mixins/mixin.js';
export default {
  components: { report, hongbao },
  mixins: [mixin],
  data() {
    return {
      starList: [
        { star: 5, percentage: 90 },
        { star: 4, percentage: 7 },
        { star: 3, percentage: 0 },
        { star: 2, percentage: 0 },
        { star: 1, percentage: 3 },
      ],
      date: new Date(),
    };
  },
  computed: {
    year() {
      return this.date.getFullYear();
    },
    today() {
      let month = this.date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let day = this.date.getDate();
      day = day < 10 ? '0' + day : day;
      return `${this.year}/${month}/${day}`;
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.tag {
  padding: 2px 10px;
  color: #7195b9;
  font-size: 14px;
  border: 1px solid #c1d2da;
  text-align: center;
  border-radius: 15px;
}
.statisticsBox {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-radius: 16px;
  background: #e5eaed;
  padding: 10px 15px;
}
.bottomBtn {
  position: fixed;
  bottom: 0;
  width: 100%;
  min-height: 130px;
  z-index: 5;
  background: linear-gradient(181deg, #fff0, #fff 46.58%, #fff3);
  display: flex;
  justify-content: center;
}
.installBtn {
  height: 48px;
  width: 250px;
  color: #fff;
  font-size: 16px;
  border-radius: 100px;
  background: #0378fc;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.xinren {
  width: 112px;
  height: 48px;
  color: #0378fc;
  background-color: #fff;
  border-width: 2px;
  border-style: solid;
  border-radius: 100px;
  border: 2px solid #0378fc;
  background: #fff;
  font-size: 16px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
